import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { AppRouter } from "./router";
import { queryClient } from "./lib/queryClient";
import "./index.css";
import { initAmplify } from "./lib/amplify";

initAmplify();

async function bootstrap() {
  // 開発時のみ、かつ相対ベースURL・モック許可時にMSWを起動
  const isDev = import.meta.env.DEV;
  const rawBase = import.meta.env.VITE_API_BASE_URL || "";
  const isRelativeBase = rawBase === "" || !/^https?:\/\//.test(rawBase);
  const useMockFlag =
    (import.meta.env.VITE_USE_MOCK ?? "true").toLowerCase() === "true";
  if (isDev && useMockFlag && isRelativeBase) {
    try {
      const { worker } = await import("./mocks/browser");
      await worker.start({ onUnhandledRequest: "bypass" });
    } catch {
      // 失敗してもアプリ起動は継続
    }
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AppRouter />
      </QueryClientProvider>
    </StrictMode>,
  );
}

bootstrap();
